import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const AGE_OK_KEY = "bl_age_ok";

// 18+ / research-use confirmation. Shown once per device (localStorage); admin routes are exempt.
export default function AgeGate({ onConfirm }) {
  const [open, setOpen] = useState(() => !localStorage.getItem(AGE_OK_KEY));

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const confirm = () => {
    localStorage.setItem(AGE_OK_KEY, new Date().toISOString());
    setOpen(false);
    onConfirm?.();
  };
  const leave = () => { window.location.href = "https://www.google.com"; };

  if (!open) return null;
  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[300] bg-[#02060F] grid place-items-center p-6" role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div className="w-full max-w-lg text-center">
        <img src="/assets/emblem.png" alt="" className="w-20 mx-auto opacity-80" />
        <div className="bl-eyebrow mt-8 text-[color:var(--bl-gold)]">Age &amp; Use Verification</div>
        <h1 id="age-gate-title" className="font-display text-white text-4xl md:text-5xl mt-4 uppercase leading-none tracking-tight">
          Researchers<br />18+ only
        </h1>
        <p className="text-white/60 text-sm mt-6 leading-relaxed">
          Regeneration Bio Labz supplies research compounds for laboratory use only. They are not for human or veterinary
          consumption. By entering you confirm that you are at least 18 years old and are purchasing for research purposes.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button onClick={confirm} data-testid="age-gate-confirm" className="bl-btn primary py-3.5 px-6 inline-flex items-center justify-center gap-2">
            <ShieldCheck size={14} /> I am 18+ and a researcher
          </button>
          <button onClick={leave} data-testid="age-gate-leave" className="bl-btn py-3.5 px-6">Leave site</button>
        </div>
        <div className="mt-8 font-mono text-[10px] tracking-[0.2em] uppercase text-white/30 flex flex-wrap justify-center gap-x-4 gap-y-2">
          <Link to="/legal/age-verification" onClick={confirm} className="hover:text-white/60">Age Verification Policy</Link>
          <Link to="/legal/disclaimer" onClick={confirm} className="hover:text-white/60">Research Disclaimer</Link>
        </div>
      </div>
    </div>
  );
}
